import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from 'react-intl';
import {Form, FieldArray} from 'formik';
import FieldInput from '../../components/FieldInput';
import FieldCheckbox from '../../components/FieldCheckbox';
import FieldDatepicker from '../../components/FieldDatepicker';
import FieldSelect from "../../components/FieldSelect";
import Button from '../../components/Button';
import ErrorValidation from '../../components/ErrorValidation';
import styles from './styles.module.scss';

const child = {
  name: '',
  ID: '',
  birthDate: null,
  inMyCustody: false,
  receiveAllowance: false,
};

const Child = ({
                 fields: {
                   name,
                   idNumber,
                   birthday,
                   inPossession,
                   receiveAllowance
                 },
                 placeholders: {
                   childNamePlaceholder,
                   childIdPlaceholder,
                 },
               }) => {
  return (
    <>
      <FieldInput
        fieldId={name}
        label={(
          <div className={styles.text}>
            <FormattedMessage
              id='step12.form.childName.input.label'
              defaultMessage={'The child\'s name'}
            />
          </div>
        )}
        placeholder={childNamePlaceholder}
        containerStyles={styles.input}
      />
      <FieldInput
        fieldId={idNumber}
        label={(
          <div className={styles.text}>
            <FormattedMessage
              id='step12.form.childId.input.label'
              defaultMessage={'ID number'}
            />
          </div>
        )}
        placeholder={childIdPlaceholder}
        containerStyles={styles.input}
      />
      <FieldDatepicker
        fieldId={birthday}
        label={(
          <div className={styles.text}>
            <FormattedMessage
              id='step12.form.childBirthday.input.label'
              defaultMessage={'Date of birth'}
            />
          </div>
        )}
        placeholder={childIdPlaceholder}
        containerStyles={styles.input}
      />
      <FieldCheckbox
        fieldId={inPossession}
        label={(
          <div className={styles.text}>
            <FormattedMessage
              id='step12.form.inPossession.label'
              defaultMessage='The boy is in my possession'
            />
          </div>
        )}
        containerStyles={styles.input}
      />
      <FieldCheckbox
        fieldId={receiveAllowance}
        label={(
          <div className={styles.text}>
            <FormattedMessage
              id='step12.form.receiveAllowance.label'
              defaultMessage='I receive a child allowance from the National Insurance Institute for the child'
            />
          </div>
        )}
        containerStyles={styles.input}
      />
    </>
  )
};

const Children = ({values, childNamePlaceholder, childIdPlaceholder}) => (
  <FieldArray name={'kidsDetails'}>
    {({remove, push}) => {
      return (
        <div>
          {
            (values.kidsDetails.length > 0) && values.kidsDetails.map((prevJob, index) => (
              <div key={index} className={`${styles.contentBlock} ${styles.moreChildren}`}>
                <Child
                  fields={{
                    name: `kidsDetails.${index}.name`,
                    idNumber: `kidsDetails.${index}.ID`,
                    birthday: `kidsDetails.${index}.birthDate`,
                    inPossession: `kidsDetails.${index}.inMyCustody`,
                    receiveAllowance: `kidsDetails.${index}.receiveAllowance`,
                  }}
                  placeholders={{
                    childNamePlaceholder,
                    childIdPlaceholder,
                  }}
                />
                {index > 0 && (
                  <Button
                    type='button'
                    variant='secondary'
                    className={styles.removeBtn}
                    onClick={() => remove(index)}
                    label={(
                      <FormattedMessage
                        id='step12.form.button.removeChild'
                        defaultMessage='- Remove child'
                      />
                    )}
                  />
                )}
              </div>
            ))
          }
          <div className={styles.contentBlock}>
            <Button
              type='button'
              variant='secondary'
              onClick={() => push(child)}
              label={(
                <FormattedMessage
                  id='step12.form.button.addChild'
                  defaultMessage='+ Add another child'
                />
              )}
            />
          </div>
        </div>
      )
    }}
  </FieldArray>
);

const Step12View = ({
                      values,
                      loadOptions,
                      isValid,
                      onKidsUnder19ExistsCheckboxChange,
                    }) => {
  const [showAliyahDate, setShowAliyahDate] = useState(false);
  const removeAliyahDate = () => {
    setShowAliyahDate(false);
    values.aliyahDate = null;
  };
  const marriedValue = useIntl().formatMessage({
    id: 'step12.form.married.label',
    defaultMessage: 'Married'
  });
  const childNamePlaceholder = useIntl().formatMessage({
    id: 'step12.form.childName.input.placeholder',
    defaultMessage: 'Write child\'s name'
  });
  const childIdPlaceholder = useIntl().formatMessage({
    id: 'step12.form.childId.input.placeholder',
    defaultMessage: 'ID number'
  });


  const isMarried = Boolean(values.firstName) || Boolean(values.lastName);

  return (
    <Form className={styles.formContainer}>
      <div className={styles.input}>
        <div className={styles.titleBold}>
          <FormattedMessage
            id='step12.form.title'
          />
        </div>
      </div>
      <FieldCheckbox
        fieldId={'kidsUnder19Exists'}
        label={(
          <div className={styles.text}>
            <FormattedMessage
              id='step12.form.haveChildren.label'
              defaultMessage='I have children who have not yet turned 19 years old'
            />
          </div>
        )}
        containerStyles={styles.input}
        onChange={onKidsUnder19ExistsCheckboxChange}
      />
      {
        values.kidsUnder19Exists && (
          <Children
            values={values}
            childIdPlaceholder={childIdPlaceholder}
            childNamePlaceholder={childNamePlaceholder}
          />
        )
      }
      {
        isMarried && (
          <div className={styles.inner}>
            <div className={`${styles.input} ${styles.title}`}>
              <FormattedMessage
                id={'step12.form.spouseDetails.title'}
                defaultMessage={'Details of the spouse for income tax'}
              />
            </div>
            <FieldSelect
              fieldId='familyStatus'
              label={(
                <FormattedMessage
                  id='step12.form.maritalStatus.label'
                  defaultMessage='Marital Status'
                />
              )}
              loadOptions={(_, callback) => callback([{label: marriedValue, value: null}])}
              isDisabled={true}
              value={{label: marriedValue, value: null}}
              containerStyles={(isMarried) ? styles.input : {}}
            />
            <div className={`${styles.input} ${styles.twoInRow}`}>
              <FieldInput
                fieldId='firstName'
                label={(
                  <FormattedMessage
                    id='step12.form.firstName.label'
                    defaultMessage='First Name'
                  />
                )}
                disabled={true}
              />
              <FieldInput
                fieldId='lastName'
                label={(
                  <FormattedMessage
                    id='step12.form.lastName.label'
                    defaultMessage='Last Name'
                  />
                )}
                disabled={true}
              />
            </div>
            <FieldInput
              fieldId='spouseID'
              label={(
                <FormattedMessage
                  id='step12.form.id.label'
                  defaultMessage='Spouse ID card'
                />
              )}
              containerStyles={styles.input}
            />
            <FieldDatepicker
              fieldId={'spouseBirthDate'}
              label={(
                <div className={styles.text}>
                  <FormattedMessage
                    id='step12.form.birthday.input.label'
                    defaultMessage={'Date of birth of the spouse'}
                  />
                </div>
              )}
              placeholder={childIdPlaceholder}
              containerStyles={styles.input}
            />
            <div className={styles.input}>
              {showAliyahDate
                ? (
                  <FieldDatepicker
                    fieldId='spouseAliyahDate'
                    label={(
                      <FormattedMessage
                        id='step12.form.aliyahDate.label'
                        defaultMessage='Aliyah date'
                      />
                    )}
                    info={
                      <div onClick={removeAliyahDate}>
                        <FormattedMessage
                          id='step12.form.aliyahDate.button.remove'
                          defaultMessage='Remove'
                        />
                      </div>
                    }
                  />
                )
                : (
                  <Button
                    variant='secondary'
                    onClick={() => setShowAliyahDate(true)}
                    label={(
                      <FormattedMessage
                        id='step12.form.button.aliyahDate'
                        defaultMessage='+ Aliyah date'
                      />
                    )}
                  />
                )}
            </div>
            <div className={styles.input}>
              <FieldSelect
                fieldId='spouseIncome'
                loadOptions={loadOptions}
                label={(
                  <FormattedMessage
                    id='step12.form.spouseIncome.label'
                    defaultMessage={'Spouse\'s income'}
                  />
                )}
                containerStyles={styles.input}
              />
            </div>
          </div>
        )
      }

      <div className={styles.inner}>
        <Button
          type='submit'
          label={(
            <FormattedMessage
              id='common.form.button.save'
              defaultMessage='Save'
            />
          )}
          className={styles.sendBtn}
        />
        {!isValid && <ErrorValidation/>}
      </div>

    </Form>
  )
};

Step12View.propTypes = {
  values: PropTypes.object,
  loadOptions: PropTypes.func,
  isValid: PropTypes.bool,
  onKidsUnder19ExistsCheckboxChange: PropTypes.func,
};

export default Step12View;
